export const MS_IN_SEC = 1000;
export const SEC_IN_MIN = 60;
export const MIN_IN_HOUR = 60;
export const HOUR_IN_DAY = 24;

export const MS_IN_MIN = SEC_IN_MIN * MS_IN_SEC;
export const MS_IN_HOUR = MIN_IN_HOUR * MS_IN_MIN;
export const MS_IN_DAY = HOUR_IN_DAY * MS_IN_HOUR;
